export * from "./types.js";
export * from "./copy.js";
export {
  calculateSetAside,
  calculateGstThreshold,
  calculateRideshareGst,
} from "./calculate.js";
export { fy2025_26 } from "./fy2025-26.js";

import type { FinancialYear } from "../types.js";
import type { SideIncomeRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";

/** Registry of side-income rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the right rules. */
export const SIDE_INCOME_RULESETS: Record<string, SideIncomeRuleSet> = {
  "2025-26": fy2025_26,
};

/** Resolve the side-income ruleset for a financial year, or throw if unknown. */
export function sideIncomeRulesFor(fy: FinancialYear): SideIncomeRuleSet {
  const rules = SIDE_INCOME_RULESETS[fy];
  if (!rules) {
    throw new Error(`no side-income ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent side-income ruleset — the default for live "this year" calcs. */
export const SIDE_INCOME_CURRENT_FY: FinancialYear = "2025-26";
